import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react'

interface IPageConfig {
  icon?: React.ReactNode
  onBack?: VoidFunction
  titleActions?: () => React.ReactNode
  actions?: () => React.ReactNode
}

interface IPageConfigContext {
  config: IPageConfig
  setConfig: (config: IPageConfig) => void
  clearConfig: () => void
}

const PageConfigContext = createContext<IPageConfigContext>({
  config: {},
  setConfig: () => {},
  clearConfig: () => {},
})

export const PageConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfigState] = useState<IPageConfig>({})

  const setConfig = useCallback((newConfig: IPageConfig) => {
    setConfigState(newConfig)
  }, [])

  const clearConfig = useCallback(() => {
    setConfigState({})
  }, [])

  return <PageConfigContext.Provider value={{ config, setConfig, clearConfig }}>{children}</PageConfigContext.Provider>
}

export const usePageConfig = () => useContext(PageConfigContext)

export const useSetPageConfig = (config: IPageConfig) => {
  const { setConfig, clearConfig } = usePageConfig()
  const configRef = useRef(config)
  configRef.current = config

  useEffect(() => {
    setConfig(configRef.current)
    return () => clearConfig()
  }, [setConfig, clearConfig])
}
